<template>
  <div class="outerCtn">
    <img
      src="@/assets/phoneJoinUs/banner1.png"
      alt=""
      srcset=""
      style="width:100%"
    />
    <div class="article">
      <p>宣传视频</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
      <div class="detail" style="padding:0">
         <video autoplay loop controls preload>
          <source src="https://file.smalleel.com//2023/08/28/%E8%BE%B0%E9%B3%97%E7%A7%91%E6%8A%808.25V3.m4v">
          </video>
      </div>
    </div>

    <div class="article">
      <p>人才理念</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
      <div class="detail">
          <div>辰鳗始终倡导开放、透明、无等级的沟通、无障碍的交流。</div>
          <div>欢迎充满活力、永怀理想、坚持奋斗、追求不凡的你，成为未来的辰鳗事业合伙人。</div>
      </div>
    </div>


    <div class="article">
      <p>公司福利</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
        <div class="detail">
            <div v-for="(item,index) in point" :key="index">
                <div class="hardWare">
                    <img :src="item.assets" alt="" style="height:20px">
                    {{item.title}}
                </div>
                <div class="hardWare-text">
                    {{item.content}}
                </div>
            </div>
        </div>
    </div>
    <div class="article">
      <p>招聘岗位</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
      <div>
        <img
        src="@/assets/phoneJoinUs/pic.png"
        alt=""
        srcset=""
        style="width:100%;margin-top:20px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import img1 from '../../../assets/phoneJoinUs/1.png'
import img2 from '../../../assets/phoneJoinUs/2.png'
import img3 from '../../../assets/phoneJoinUs/3.png'
export default {
  data() {
    return {
        point:[
            {assets:img1,content:'舒适宽松的办公环境，无限量供应零食，鼓励员工劳逸结合。',title:'环境',},
            {assets:img2,content:'每年年底举行的年会是辰鳗最重要的盛会之一，年会上，向员工传递公司战略、业务布局与管理思路，并表彰优秀团队。',title:'年会',},
            {assets:img3,content:'自公司创立以来，每个季度至少一次团建，全体员工欢聚一堂，做游戏、BBQ、生日趴等，增进员工感情，提升团队凝聚力。',title:'不定期团建',},
        ],
    };
  },
  mounted() {
    this.getRecruit()
  },
  methods:{
      getRecruit(){
      this.$axios.post('/api/websiteRecruit/websiteList',{start: 1,limit: 50}).then(res=>{
        this.list = res.data.data.records
        console.log(this.list,'-----------------------')
      })
  }
  }
};
</script>

<style lang="scss" scoped>
.outerCtn {
  background-image: url('../../../assets/productCenter/Bg.png');
  background-position: center;
  background-size: cover;
  color: white;
  min-height: 100vh;
  .article {
    padding: 40px 20px 20px 20px;
    text-align: left;
    background-color: #121825;
    p {
      font-size: 22px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      padding-bottom: 10px;
      text-align: center;
    }
    .imgCtn {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width:84px;
        height: 3px;
      }
    }
  }
    .detail{
        background-color: #2d2f33;
        margin-top: 20px;
        border-radius: 4px;
        overflow: hidden;
        padding: 26px 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        font-size: 12px;
        div{
            letter-spacing: 1px;
            line-height: 20px;
        }
        .hardWare{
            text-align: left;
            display: flex;
            font-size: 14px !important;
            font-weight: 500;
            color: #3170FF;
            align-items: center;
            margin-top: 6px;
            img{
                margin-right: 8px;
            }
            }
        .hardWare-text{
            font-size: 12px;
            text-indent: 0;
            margin-left: 30px;
        }
    }
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneJoinUs.vue